import type { SxProps, Theme } from "@mui/material/styles";

export const card: SxProps<Theme> = {
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: { xs: 2, md: 2.75 },
  boxShadow: { xs: 0, md: 1 },
  p: { xs: 2, md: 2.5 },
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
};

export const title: SxProps<Theme> = {
  fontSize: { xs: "0.84375rem", md: "0.9375rem" },
  fontWeight: 700,
  mb: 0.75,
};

export const desktopRow: SxProps<Theme> = {
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  justifyContent: "space-between",
  py: 1.5,
  borderTop: 1,
  borderColor: "divider",
  fontSize: "0.78125rem",
};

export const desktopLeft: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
};

export const desktopRight: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.75,
};

export const desktopAmount: SxProps<Theme> = {
  fontWeight: 600,
};

export const mobileRow: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  flexDirection: "column",
  gap: 0.25,
  py: 1.25,
  borderTop: 1,
  borderColor: "divider",
};

export const mobileTop: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const mobileShopName: SxProps<Theme> = {
  fontSize: "0.75rem",
  fontWeight: 600,
};

export const mobileAmount: SxProps<Theme> = {
  fontSize: "0.75rem",
  fontWeight: 700,
};

export const mobileDate: SxProps<Theme> = {
  fontSize: "0.65625rem",
  color: "text.secondary",
};

export const secondaryText: SxProps<Theme> = {
  color: "text.secondary",
};
